import type Item from 'owa-service/lib/contract/Item';
import type ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import {
    COPILOT_DRAFT_GENERATION_PROPERTIES_NAME,
    MESSAGE_PROPERTY_SET_ID,
    parseCopilotDraftGenerationProperties,
    type CopilotDraftGenerationProperties,
} from 'owa-copilot-draft-generation-shared';
import {
    IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME,
    PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME,
} from './constants';

export default function extractProactiveDraftFields(item: Item): {
    IsCopilotProactiveDraft?: boolean;
    CopilotDraftGenerationProperties?: CopilotDraftGenerationProperties;
} {
    if (!item.ExtendedProperty) {
        return {};
    }
    let isCopilotProactiveDraft: boolean | undefined;
    let copilotGenerationProperty: ExtendedPropertyType | undefined;
    let legacyGenerationProperty: ExtendedPropertyType | undefined;
    for (const prop of item.ExtendedProperty) {
        if (prop?.ExtendedFieldURI?.PropertySetId?.toLowerCase() !== MESSAGE_PROPERTY_SET_ID) {
            continue;
        }
        const name = prop.ExtendedFieldURI.PropertyName;
        if (
            name === IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME &&
            prop.ExtendedFieldURI.PropertyType === 'Boolean'
        ) {
            isCopilotProactiveDraft =
                prop.Value === true ||
                (typeof prop.Value === 'string' && prop.Value.toLowerCase() === 'true');
        } else if (name === COPILOT_DRAFT_GENERATION_PROPERTIES_NAME) {
            copilotGenerationProperty = prop;
        } else if (name === PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME) {
            legacyGenerationProperty = prop;
        }
    }
    return {
        IsCopilotProactiveDraft: isCopilotProactiveDraft,
        CopilotDraftGenerationProperties: parseCopilotDraftGenerationProperties(
            (copilotGenerationProperty ?? legacyGenerationProperty)?.Value
        ),
    };
}
